module.exports = __webpack_public_path__ + "img/pic3.f8d16a75.svg";